
<template>
    <div>
        <stickyNav v-if="enableStickyNav" />
         <section class="api-bg">
            <div class="container shape-container pt-5">
                <div class="pt-md-5">
                    <div class="col-lg-8 pt-5">
                        <div class="row pt-5">
                            <h3 class="display-2 mt-5">BUILD YOUR VERY <br>OWN SOLUTION
                                <span class="lead">Faster and easier</span>
                            </h3>
                            <p class="lead text-dark mt-0">Integrate our APIs into your application and <br> develop your own solution from scratch.
                                <br>It's a lot faster.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="pb-5 my-5 px-lg-0 px-4">
            <div class="container">
                <div class="text-center justify-content-center">
                    <div class="col-lg-12">
                        <h2 class="display-3 text-dark">Customer Accessibility</h2>
                        <p class="lead mb-5">We offer a wide range of products and services.</p>
                    </div>
                </div>
                <div class="row row-grid align-items-center pb-md-5">
                    <div class="col-md-6 order-md-2" data-aos="fade-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                        <div class="pl-md-5">
                            <div class="mb-4">
                                <img src="img/icons/common/enterprise.svg" class="img-fluid">
                            </div>
                            <p class="lead">
                                Use our technology to build your solution. Run on up to date systems with our API. Back end you can trust and build on. 
                                This system saves your time and effort, making your business processes easier and faster
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 order-md-1">
                        <img src="img/theme/api-hero.png" class="img-fluid rounded shadow-lg floating">
                    </div>
                </div>
            </div>
        </section>

        <section class="values-section py-5">
            <div class="container">
                <div class="container">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-dark">Features</h2>
                        <p class="lead text-dark">What our custom pages offer</p>
                    </div>
                </div>
                <div class="row row-grid mt-5 text-center">
                    <div class="col-lg-4">
                        <div class="mb-4">
                            <img src="img/icons/common/good.svg" class="img-fluid">
                        </div>
                        <h5 class="text-dark mt-3">Business ready</h5>
                        <p class="mt-3 lead-2">With the right basic knowledge and direction you can use our API to build your own solutions and have your own business</p>
                    </div>
                    <div class="col-lg-4">
                        <div class="mb-4">
                            <img src="img/icons/common/good.svg" class="img-fluid">
                        </div>
                        <h5 class="text-dark mt-3">Accurate documentation</h5>
                        <p class="mt-3 lead-2">Our APIs are well documented with each endpoint and parameters needed to build your own solution smoothly</p>
                    </div>
                    <div class="col-lg-4">
                        <div class="mb-4">
                            <img src="img/icons/common/good.svg" class="img-fluid">
                        </div>
                        <h5 class="text-dark mt-3">Faster and simpler</h5>
                        <p class="mt-3 lead-2">Request are super fast and help you build fast solutions for your clients for better user experience</p>
                    </div>
                </div>
                </div>
            </div>
        </section>

        <section class="section bg-white pt-md-5 mt-5 px-lg-0 px-4">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 pr-lg-5">
                        <div class="card bg-code shadow text-white border-0 pt-4 pb-2">

                        <highlightjs langauge="js" :code="code" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-lg-5">
                            <div class="mb-4">
                                <img src="img/icons/common/access.svg" class="img-fluid">
                            </div>
                            <h3>All you need to build</h3>
                            <p class="lead my-2">Integrate our APIs</p>
                            <p>We have documented a set of developer tools that will make it easier for you to learn how to work with our APIs. 
                                These resources will help you build faster and test your applications before you deploy them to your users.</p>
                            <base-button tag="a" href="#" type="primary" class="mt-3">
                                Learn more
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import StickyNav from '../../layout/StickyHeader';

export default {
  name: "enterprise",
  components: {
    StickyNav,
  },
  data() {
        return {
        enableStickyNav: null,
        code: '# import package \nimport topupbox \n \n#initialize SDK \nusername = "YOUR_USERNAME" \n \n# Initialize a service e.g. airtime \n airtime = topupbox.AIRTIME \n \nresponse = airtime.send([{ \n  beneficiary: "+2547XXXXXXXX", \n  amount: "200" \n}]) \n \nprint(response)'
        }
    },
    mounted() {
        // console.log('Index page created')
        // console.log('Sticky Nav mounted')
        window.addEventListener('scroll', this.handleNavDisplay)
    },
    // created() {},
    destroyed() {
        window.addEventListener('scroll', this.handleNavDisplay)
    },
    methods: {
        handleNavDisplay() {
        var y = window.scrollY
        if (y > 100 && !this.enableStickyNav) {
            // console.log ('Display New Menu')
            this.enableStickyNav = true
        } else if (y < 100 && this.enableStickyNav) {
            // console.log('Hide sticky Nav')
            this.enableStickyNav = false
        }
        }
    }
};
</script>
